var get = require('./get');

    var UNDEF;

    /**
     * Check if object has nested property.
     */
    function has(obj, prop){
        return get(obj, prop) !== UNDEF;
    }

    module.exports = has;






//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/has.js
// module id = 21
// module chunks = 0